import { render, staticRenderFns } from "./transactionQueryTab.vue?vue&type=template&id=aff85772&"
import script from "./transactionQueryTab.vue?vue&type=script&lang=js&"
export * from "./transactionQueryTab.vue?vue&type=script&lang=js&"
import style0 from "./transactionQueryTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "transactionQueryTab.vue"
export default component.exports